export default "__VITE_ASSET__5W7ktB6f__"